import { render, staticRenderFns } from "./HorizontalTextSlider.vue?vue&type=template&id=3723380a&scoped=true"
import script from "./HorizontalTextSlider.vue?vue&type=script&lang=js"
export * from "./HorizontalTextSlider.vue?vue&type=script&lang=js"
import style0 from "./HorizontalTextSlider.vue?vue&type=style&index=0&id=3723380a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3723380a",
  null
  
)

export default component.exports